import name from './name'

const selectSliceData = state => state[name]
const selectSkillBite = state => selectSliceData(state).skillBite

const selectedSelectedSessionId = state => selectSliceData(state).selectedSessionId
const selectedSelectedSectionId = state => selectSliceData(state).selectedSectionId
const selectedSelectedPageId = state => selectSliceData(state).selectedPageId

const selectSelectedSession = state => {
  const skillBite = selectSkillBite(state)
  const selectedSessionId = selectedSelectedSessionId(state)
  if (!skillBite?.sessions || !selectedSessionId) return null
  return skillBite.sessions.find(session => session.id === selectedSessionId)
}
const selectSelectedSection = state => {
  const selectedSession = selectSelectedSession(state)
  const selectedSectionId = selectedSelectedSectionId(state)

  if (!selectedSession || !selectedSession.sections || !selectedSectionId) return null
  return selectedSession.sections.find(section => section.id === selectedSectionId)
}
const selectSelectedPage = state => {
  const selectedSection = selectSelectedSection(state)
  const selectedPageId = selectedSelectedPageId(state)
  if (!selectedSection || !selectedSection.pages || !selectedPageId) return null
  return selectedSection.pages.find(page => page.id === selectedPageId)
}

const selectCanEditStructure = state => !selectSliceData(state).skillBite.published && selectSliceData(state).editMode
const selectEditMode = state => selectSliceData(state).editMode
const selectIsPublished = state => selectSliceData(state).skillBite.published

const selectSkillBiteCommitmentBlocks = state => {
  const blocks = []
  const skillBite = selectSkillBite(state)

  skillBite.sessions.forEach(session => {
    session.sections.forEach(section => {
      section.pages.forEach(page => {
        page.blocks.forEach(block => {
          if (block.type === 'commitment') {
            blocks.push({
              id: block.id,
              label: block?.data?.commitmentLabel,
              session: { id: session.id, name: session.name, order: session.order },
              section: { id: section.id, name: section.name, order: section.order },
              page: { id: page.id, order: page.order }
            })
          }
        })
      })
    })
  })

  return blocks
}

export {
  selectSkillBite,
  selectSelectedSession,
  selectSkillBiteCommitmentBlocks,
  selectSelectedSection,
  selectSelectedPage,
  selectIsPublished,
  selectEditMode,
  selectCanEditStructure
}
